import * as React from "react";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";

import DestinationSampleReviews from "./components/DestinationSampleReviews";
import { DestinationOverallRating } from "./components/DestinationOverallRating";
import DestinationUserReviewsDialog from "./components/DestinationUserReviewsDialog";

import { DestinationUserReviewsProps } from "./typings";
import { ViewType } from "./DestinationUserReviewsEnums";
import { withStores } from "stores";
import { useLocalization } from "@shared-ui/localization-context";

const NAME_FOR_TRACKING = "TG.LP.Dest.UserReviews";

const DestinationUserReviews = withStores("routeStore")((props: DestinationUserReviewsProps) => {
  const { flexComponent, routeStore } = props;
  const { model } = flexComponent;
  const { destinationName, reviews, aggregateReview, countPerRating, title } = model;
  const { formatText } = useLocalization();

  if (!(destinationName && reviews?.length && aggregateReview && countPerRating)) {
    return null;
  }

  const { totalReviews, totalRatings, averageRating } = aggregateReview;

  if (!(totalReviews && totalRatings && averageRating)) {
    return null;
  }

  const toggleAllDestinationReviews = (): void => {
    const isDialogOpen = routeStore.queryParams.destDialogReviews === "open";

    if (isDialogOpen) {
      routeStore.closeDialog("destDialogReviews");
    } else {
      routeStore.updateSearch({ destDialogReviews: "open" });
    }
  };

  return (
    <>
      {model.view === ViewType.DETAIL && (
        <div
          className="DestinationUserReviews uitk-cell all-cell-1-1 detailView"
          id={flexComponent.id}
          data-fm={flexComponent.fmId}
        >
          <DestinationSampleReviews
            title={title}
            nameForTracking={NAME_FOR_TRACKING}
            reviews={reviews}
            destinationName={destinationName}
            totalReviews={totalReviews}
            totalRatings={totalRatings}
            countPerRating={countPerRating}
            avgRating={averageRating}
            toggleAllDestinationReviews={toggleAllDestinationReviews}
          />
        </div>
      )}

      {model.view === ViewType.SUMMARY && (
        <div
          className="DestinationUserReviews uitk-cell all-grid-align-center defaultView"
          id={flexComponent.id}
          data-fm={flexComponent.fmId}
        >
          <DestinationOverallRating
            totalReviews={totalReviews}
            avgRating={averageRating}
            toggleAllDestinationReviews={toggleAllDestinationReviews}
            nameForTracking={NAME_FOR_TRACKING}
          />
        </div>
      )}

      <QueryRoute query={{ destDialogReviews: "open" }}>
        <Layer id="destination-reviews" onDismiss={toggleAllDestinationReviews}>
          <DestinationUserReviewsDialog
            nameForTracking={NAME_FOR_TRACKING}
            reviewDialogTitle={formatText("destinationReviews.cityReviews", destinationName)}
            reviews={reviews}
            toggleAllDestinationReviews={toggleAllDestinationReviews}
          />
        </Layer>
      </QueryRoute>
    </>
  );
});

export default DestinationUserReviews;
